/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { FileApi } from "../clients";
import { wrap } from "../wrap";

export const fileApi = {
  getFileDownload: wrap(FileApi, FileApi.prototype.getFileDownload),
  postUploadFile: wrap(FileApi, FileApi.prototype.postUploadFile),
};
